export const dateAppointment = (startAt) => {
    const date = startAt.format("DD MMMM YYYY [à] HH:mm")

    return `${startAt.format("dddd DD MMMM YYYY").charAt(0).toUpperCase() 
            + startAt.format('dddd').slice(1)} ${date}`
}